/* NUPEP Research Assessment — step logic + research-category matching */
(function () {
  var WEIGHT = { 1: 2, 2: 1 }; // step 1 (primary focus) counts double

  function init(root) {
    if (root.dataset.naInit) return;
    root.dataset.naInit = '1';

    var steps = [].slice.call(root.querySelectorAll('.na-step'));
    var bars = [].slice.call(root.querySelectorAll('.na-progress span'));
    var label = root.querySelector('[data-na-stepnum]');
    var intro = root.querySelector('[data-na-intro]');
    var wrap = root.querySelector('.na-quiz__wrap');
    var results = root.querySelector('[data-na-results]');
    var list = root.querySelector('[data-na-list]');
    var pool = root.querySelector('[data-na-pool]');
    var topN = parseInt(root.getAttribute('data-top'), 10) || 3;
    var current = 1;

    function show(n, quiet) {
      current = n;
      steps.forEach(function (s) { s.hidden = parseInt(s.getAttribute('data-step'), 10) !== n; });
      bars.forEach(function (b, i) { b.classList.toggle('is-done', i < n); });
      if (label) label.textContent = n;
      root.querySelectorAll('.na-error').forEach(function (e) { e.textContent = ''; });
      if (!quiet) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function picked(step) {
      return [].slice.call(root.querySelectorAll('.na-step[data-step="' + step + '"] input[type="checkbox"][data-cats]:checked'));
    }

    function err(step, msg) {
      var el = root.querySelector('.na-step[data-step="' + step + '"] .na-error');
      if (el) el.textContent = msg;
    }

    function score() {
      var totals = {};
      [1, 2].forEach(function (step) {
        picked(step).forEach(function (input) {
          input.getAttribute('data-cats').split(',').forEach(function (k) {
            k = k.trim().toLowerCase();
            if (k) totals[k] = (totals[k] || 0) + WEIGHT[step];
          });
        });
      });
      return totals;
    }

    function showResults() {
      var totals = score();
      var cats = [].slice.call(pool.querySelectorAll('.na-cat'));
      cats.forEach(function (c, i) {
        c._score = totals[(c.getAttribute('data-key') || '').toLowerCase()] || 0;
        c._order = i;
      });
      var ranked = cats.filter(function (c) { return c._score > 0; })
        .sort(function (a, b) { return b._score - a._score || a._order - b._order; })
        .slice(0, topN);

      // nothing matched (misconfigured keys) -> fall back to first categories
      if (!ranked.length) { ranked = cats.slice(0, topN); ranked.forEach(function (c) { c._score = 1; }); }

      var top = ranked[0]._score;
      cats.forEach(function (c) { pool.appendChild(c); });
      list.innerHTML = '';
      ranked.forEach(function (c, i) {
        c.querySelector('[data-na-rank]').textContent = '#' + (i + 1);
        var pct = Math.max(40, Math.round((c._score / top) * 100));
        c.querySelector('[data-na-match]').textContent = i === 0 ? 'Best research match' : 'Match ' + pct + '%';
        list.appendChild(c);
      });

      steps.forEach(function (s) { s.hidden = true; });
      if (intro) intro.hidden = true;
      wrap.classList.add('na-quiz__wrap--results');
      results.hidden = false;
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function reset() {
      root.querySelectorAll('input[type="checkbox"]').forEach(function (i) { i.checked = false; });
      results.hidden = true;
      if (intro) intro.hidden = false;
      wrap.classList.remove('na-quiz__wrap--results');
      show(1);
    }

    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-na-action]');
      if (!t) return;
      var a = t.getAttribute('data-na-action');
      if (a === 'next') {
        if (!picked(1).length) return err(1, 'Please select at least one research focus to continue.');
        show(2);
      } else if (a === 'back') {
        show(1);
      } else if (a === 'submit') {
        if (!picked(2).length) return err(2, 'Please select at least one research parameter.');
        var ack = root.querySelector('[data-na-ack]');
        if (ack && !ack.checked) return err(2, 'Please confirm the research-use-only acknowledgement to view your matches.');
        showResults();
      } else if (a === 'reset') {
        reset();
      }
    });

    show(1, true);
  }

  function boot() { document.querySelectorAll('[data-na-quiz]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector && e.target.querySelector('[data-na-quiz]');
    if (r) init(r);
  });
})();
